import { Button } from "@/components/ui/button";
import { CircleCheck } from "lucide-react";

interface ImportantNoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedRegion: string;
}

export const ImportantNoteModal = ({
  isOpen,
  onClose,
  selectedRegion,
}: ImportantNoteModalProps) => {
  if (!isOpen) return null;

  // Determine if region is Saudi Arabia
  const isSaudiArabia = selectedRegion.toLowerCase() === "ksa";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative mx-4 max-w-xl rounded-2xl bg-white p-8 shadow-2xl">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-xl text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>

        {/* Header */}
        <h2 className="mb-6 text-xl font-semibold text-gray-800">
          Important Note
        </h2>

        {/* Content - Different for Saudi Arabia */}
        {isSaudiArabia ? (
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-800">
                Intravenous infusion once every
              </h3>
              <p className="text-lg font-semibold text-gray-800">
                4-8 weeks. 4 Weeks for ≥ 5 to &lt; 10 kg and ≥ 10 to &lt; 20 kg.
              </p>
            </div>

            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2">
                  <CircleCheck className="h-5 w-5 text-black" />
                </div>
                <div>
                  <span className="text-gray-800">
                    Dose administration rate is weight-dependent and takes{" "}
                  </span>
                  <span className="text-xl font-medium">1.3–1.8 minutes</span>
                  <span className="text-gray-800"> for maintenance doses</span>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2">
                  <CircleCheck className="h-5 w-5 text-black" />
                </div>
                <div>
                  <span className="text-gray-800">
                    Infusions must be administered by a{" "}
                  </span>
                  <span className="text-xl font-medium">
                    healthcare professional.
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">
              Intravenous infusion once every 8 weeks
            </h3>

            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2">
                  <CircleCheck className="h-5 w-5 text-black" />
                </div>
                <div>
                  <span className="text-gray-800">
                    Dose administration rate is weight-dependent and takes{" "}
                  </span>
                  <span className="text-xl font-medium">30–75 minutes</span>
                  <span className="text-gray-800"> for maintenance doses</span>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2">
                  <CircleCheck className="h-5 w-5 text-black" />
                </div>
                <div>
                  <span className="text-gray-800">
                    Infusions must be administered by a{" "}
                  </span>
                  <span className="text-xl font-medium">
                    healthcare professional.
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Done Button */}
        <div className="mt-8 flex justify-end">
          <Button
            onClick={onClose}
            className="rounded-full bg-teal-600 px-12 py-3 font-semibold text-white hover:bg-teal-700"
          >
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};
